import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page65() {
  useEffect(() => {
    document.title = "Маяк — Страница 64"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page63" />
        <ForwardLink href="/page65" />
      </div>

      <p style={{ textAlign: "right" }}>64.</p>
      <p>ВОДА КАПАЕТ с потолка в ведро.</p>
      <p>
        МОЛОДОЙ крадется к СТАРИКУ, стараясь не создавать<br/>
        шум. Звуки ШТОРМА снаружи помогают скрыть некоторые<br/>
        из его движений. И кап... кап... кап...
      </p>
      <p>СТАРИК продолжает храпеть...</p>
      <p>Каждый шаг беззвучен...</p>
      <p>Кап... кап... кап...</p>
      <p>
        Он протягивает руку и разворачивается как приманка в замедленной<br/>
        съемке, вылавливая... МЕДНЫЕ КЛЮЧИ...
      </p>
      <p>МОЛОДОЙ видит потную ГЛОТКУ СТАРИКА...</p>
      <p>Пауза.</p>
      <p>МОЛОДОЙ медленно вынимает НОЖ...</p>
      <p>Еще один шаг вперед...</p>
      <p>Половицы выдают МОЛОДОГО громким <u>СКРИПОМ</u>.</p>
      <p>
        МОЛОДОЙ останавливается. <i>Пойман!</i> Он быстро прячет руку с ножом<br/>
        за спину.
      </p>
      <p>СТАРИК открывает один глаз.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Странный способ носить обувь.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Просто не хотел Вас будить, вот и все.
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>Ночка длинная.</p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        И все в этом духе.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Мм-хм.<br/>
        <br/>
        Солнце стоит над верфью.<br/>
        Лучше подмигни мне, прежде чем <br/>
        день приблизится к концу.
      </p>
      <p>СТАРИК <u>ПЕРДИТ</u>.</p>
      <p>Пауза.</p>
      <p>МОЛОДОЙ стоит неподвижно.</p>
      <p style={{ textAlign: "right" }}>64.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page63" />
        <ForwardLink href="/page65" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710631896/the-lighthouse-script/bt05hjrek4fexp1glfox.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page65;
